import { Box, Icon, Link } from '@chakra-ui/react';
import { IconType } from 'react-icons';
import { NavLink } from 'react-router-dom';

interface INavItemProps {
	onClick: () => void;
	icon: IconType;
	text: string;
	to: string;
}

export default function wNavItem(props: INavItemProps) {
	return (
		<Link onClick={props.onClick} as={NavLink} to={props.to} activeClassName="active" _hover={{ textDecor: 'none' }}>
			<Box
				__css={{
					'.active &': {
						bg: 'blackAlpha.100',
					},
				}}
				display="flex"
				alignItems="center"
				px={5}
				py={3}
				my={2}
				mx="4"
				borderRadius="lg"
				role="group"
				cursor="pointer"
				color="black"
				fontWeight={500}
				fontSize="md"
				transition="0.6s"
				_hover={{ bg: 'blackAlpha.50', transform: 'scale(1.02)', transformOrigin: 'center' }}
			>
				<Icon
					fontSize="lg"
					mr="2.5"
					as={props.icon}
					transition="transform 1s"
					transitionDelay=".1s"
					_groupHover={{ transform: 'scale(1.1)', transformOrigin: 'center' }}
				/>
				{props.text}
			</Box>
		</Link>
	);
}
